import React from 'react';
import TabItem, { TabItemPropsType } from '../../atoms/TabItem';

import Styles from './index.module.scss';

type TabPropsType = {
  items: Array<Omit<TabItemPropsType, 'isActive' | 'onClick'>>,
  currentActive?: string
  onClick?: (key: string) => void;
}

const Tabs: React.FC<TabPropsType> = ({
  items,
  currentActive,
  onClick
}) => {
  return (
    <div className={Styles.container}>
      {
        items.map(item => <TabItem
          onClick={onClick}
          isActive={item.value === currentActive}
          key={item.value as string}
          {...item}
        />
        )
      }
    </div>
  )
}

export default Tabs;
